/**
 * Match the backend's format-switch family contract.
 *
 * Most canonical ids use their first token to group interchangeable formats
 * (for example NAD injection and NAD nasal). GHK-Cu skin cream and scalp foam
 * are separate treatments with separate intakes, so owning one must never
 * turn the other into a format switch or satisfy it inside a protocol stack.
 */
export function productFormatFamily(canonicalProductId: string): string {
  const productId = canonicalProductId.trim().toLowerCase();

  if (productId.startsWith('ghk-cu-skin-')) return 'ghk-cu-skin';
  if (productId.startsWith('ghk-cu-foam-')) return 'ghk-cu-hair';

  return productId.split('-', 1)[0];
}
